import http from '@/http';

import {
  SETTINGS,
  LOGOUT,
  RESET_STATS,
  SNACKBAR,
  CLEAR_USER_PREF,
} from '@/store/types';

const createLoginHook = router => (store) => {
  http.interceptors.request.use((config) => {
    const newConfig = { ...config };
    const tcloudParams = {
      locali: store.getters['Session/localiAttivi'].join(','),
      modalita: store.getters['Session/modalita'],
      calendarFrom: config.headers.calendarFrom || store.getters['Session/calendar'].from,
      calendarTo: config.headers.calendarTo || store.getters['Session/calendar'].to,
      concordati: store.getters['Session/mostraConcordati'],
    };

    newConfig.headers['tcloud-params'] = btoa(JSON.stringify(tcloudParams));

    return newConfig;
  });

  http.interceptors.response.use(
    response => response,
    (error) => {
      if (error.response.status === 401 && store.getters['Session/loggedIn']) {
        store.dispatch(`Session/${LOGOUT}`);
      } else if (error.response.status === 401) {
        store.commit(`Session/${CLEAR_USER_PREF}`);
      } else if (error.response.status === 500) {
        store.commit(`Session/${SNACKBAR}`, { type: 'ERROR', msg: 'Il server ha riscontrato un errore' });
      }
      return Promise.reject(error);
    },
  );

  if (store.state.Session.token) {
    http.defaults.headers.Authorization = `Bearer ${store.state.Session.token}`;
    store.dispatch(`Session/${SETTINGS}`, false);
  }

  store.subscribe((mutation) => {
    if (mutation.type === `Session/${LOGOUT}`) {
      router.replace('/');
      store.commit(`Stats/${RESET_STATS}`);
      delete http.defaults.headers.Authorization;
    }
  });
};

export default createLoginHook;
